module.exports = __webpack_public_path__ + "img/detail-star.02ede480.svg";